import moment from "moment";

import { formatDateAccordingToTimezoneUsingMoment } from "../../../../../utils/constants";
import { getOrganizationDetailDataModel, organizationUserDataModel, userAssignmentRoleDataModel } from "../../../../../models/axiosModel";
import { getCurrentOrganizationDetails, getOrganizationNewRole, last_updated_at_timestamp_format } from "../../organizationConstants";

interface Props {
    organizationDetails: getOrganizationDetailDataModel[] | null,
    organization_id: string | null,
    timezoneHour: string,
    userAssignmentRoleData: userAssignmentRoleDataModel[] | null
}

export const getOrganizationUserDataForTeams = (props: Props): organizationUserDataModel[] => {

    const { organizationDetails, organization_id, timezoneHour, userAssignmentRoleData } = props;

    const getOrganizationUserData = () => {
        if (organizationDetails) {
            const userData: organizationUserDataModel[] = getCurrentOrganizationDetails(organizationDetails, organization_id)?.organization_user_data?.map((user: organizationUserDataModel) => {
                return {
                    ...user,
                    last_updated_at_timestamp: formatDateAccordingToTimezoneUsingMoment(user?.last_updated_at_timestamp, timezoneHour),
                    chronox_user_role_name: getOrganizationNewRole(userAssignmentRoleData, user?.user_assignment_id)?.chronox_user_role_name ?? "-",
                    chronox_user_role_id: getOrganizationNewRole(userAssignmentRoleData, user?.user_assignment_id)?.chronox_user_role_id ?? "-",
                }
            })?.sort((a: organizationUserDataModel, b: organizationUserDataModel) => {
                const timeA = moment(a.last_updated_at_timestamp).format(last_updated_at_timestamp_format);
                const timeB = moment(b.last_updated_at_timestamp).format(last_updated_at_timestamp_format);
                return timeB.localeCompare(timeA)
            });

            return userData;
        }
        return [];
    }

    return (
        getOrganizationUserData()
    );
};
